import React, { useState, useEffect } from "react";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Subject2Header from "./Subject2Header";
import SubjectCreate from "./SubjectCreate";

const Subject = () => {
  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <Subject2Header />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <SubjectCreate />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Subject;
